import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import {
  fileSearchResultsSchema,
  type FileSearchScope,
} from "@/lib/data/schemas/files";

export const searchFiles = async (
  filters: FileSearchScope & { q: string },
  cursor?: string,
  signal?: AbortSignal,
) => {
  const { data } = await authenticatedFastApiAxiosInstance.get(
    "files/v2/search",
    {
      params: { ...filters, limit: 30, cursor },
      signal,
    },
  );
  return fileSearchResultsSchema.parse(data);
};
